import { ESdChangeReason, RightPanelType, ViewPart, Visibility } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../shared/pure-sd";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";

export interface IHappyPathButtonState {}

export interface IHappyPathButtonProps {}

class HappyPathButton extends PureSdComponent<IHappyPathButtonProps & IWithSDProps, IHappyPathButtonState> {
  constructor(props: IHappyPathButtonProps & IWithSDProps) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <>
        {this.props.sd.getVisibility(ViewPart.HappyPathButton) === Visibility.Visible && (
          // <KuikaTooltip position="left" content="Happy Path">
          <KuikaButton
            data-testid="workflowHappyPathButton"
            type="tertiary"
            size="md"
            isIcon
            color="neutral"
            active={this.props.sd.getActiveRightPanel() === RightPanelType.HappyPath}
            onClick={() => this.props.sd.setActiveRightPanelByClick(RightPanelType.HappyPath)}
          >
            <KuikaSvg name="arrow-guide" width={18} height={18} pointer />
          </KuikaButton>
          // </KuikaTooltip>
        )}
      </>
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    if (
      changeReason === ESdChangeReason.ChangeSelectedDiByCanvasFrame ||
      changeReason === ESdChangeReason.ChangeSelectedDiByTools ||
      changeReason === ESdChangeReason.DragDropDi ||
      changeReason === ESdChangeReason.DragDropBlock
    ) {
      return true;
    }
    return false;
  };
}

const happyPathButton = withSD<IHappyPathButtonProps>(HappyPathButton);
export { happyPathButton as HappyPathButton };
